module.exports = __webpack_public_path__ + "static/media/pm.c734af1a.svg";